import { Certificate } from "../Certificate";

const apiUrl = "/db";

const fetchApi = (url: string, options?: RequestInit) => {
  return fetch(`${apiUrl}${url}`, options).then((response) => response.json());
};

export const insertCertificatesLog = (payload: Certificate) =>
  fetchApi(`/certificateslog`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

export const getAllCertificatesLogs = (pageNum: number) =>
  fetchApi(`/certificateslogs?page=${pageNum}`);

export const updateCertificatesLogById = (id: any, payload: Certificate) =>
  fetchApi(`/certificateslog/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

export const deleteCertificatesLogById = (id: any) =>
  fetchApi(`/certificateslog/${id}`, {
    method: "DELETE",
  });

export const getCertificatesLogById = (id: any) =>
  fetchApi(`/certificateslog/${id}`);

const apis = {
  insertCertificatesLog,
  getAllCertificatesLogs,
  updateCertificatesLogById,
  deleteCertificatesLogById,
  getCertificatesLogById,
};

export default apis;
